// Styles
import styles from './TablePaginationPerPage.module.css';

/**
 * TablePaginationPerPage component
 * @param {object} props - Component props
 * @param {string} props.label - Summary label (e.g. total results count)
 * @param {Array<TablePaginationOptions>} props.options - Array of options with label and value
 * @param {Function} props.children - Render function that receives option and returns button component
 * @returns {JSX.Element} The TablePaginationPerPage component
 */
function TablePaginationPerPage({
  label,
  options,
  children,
}) {
  return (
    <div className={styles['table-pagination-per-page']}>
      <div className={styles['table-pagination-per-page-buttons']}>
        {options.map((option) => children(option))}
      </div>
      <span className={styles['table-pagination-per-page-label']}>
        {label}
      </span>
    </div>
  );
}

export default TablePaginationPerPage;
